import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { Promocion, SavePromocion } from '../../modelos/Promocion';
import { PromocionesService } from '../../services/promociones.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { ApiResponse } from 'src/app/model/interfaces/response';
import { downloadBase64File } from 'src/utils/utils';

@Component({
  selector: 'app-editar-promocion',
  templateUrl: './editar-promocion.component.html',
  styleUrls: ['./editar-promocion.component.css']
})
export class EditarPromocionComponent implements OnInit {

  promocion?: Promocion;
  cmbTipoPromocion = [];
  loading = false;

  @ViewChild('fileGroupInput')
  fileGroupInput: ElementRef;

  @ViewChild('fileBonosInput')
  fileBonosInput: ElementRef;

  get condicionMarca() {
    const value = this.promocion.cond_marca_submarca;
    return value == 1 || value == 2;
  }
  get condicionGrupoCliente() {
    const value = this.promocion.cond_grupo_cliente;
    return value == 1 || value == 2;
  }
  get condicionCliente() {
    const value = this.promocion.cond_cliente;
    return value == 1 || value == 2;
  }

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly toastrService: ToastrService,
    private readonly promocionesService: PromocionesService,
    private readonly _util: UtilsService
  ) {
  }

  ngOnInit(): void {
    this.tiposDePromociones();
  }

  getPromocion(id: string) {
    this.loading = true;
    this.promocionesService.buscarPromo(id).subscribe((res) => {
      this.promocion = res;
      this.loading = false;
    }, (error) => this.loading = false);
  }

  tiposDePromociones() {
    this.loading = true;
    this.promocionesService.tiposDePromociones().subscribe(
      (resp) => {
        this.cmbTipoPromocion = Object.entries(resp).map(( [k, v] ) => ({
          id: v as number,
          descripcion: k
        }));
        this.cmbTipoPromocion = this.cmbTipoPromocion.filter((item) => item.id > 0);
        // this.cmbTipoPromocion = resp;
        this.loading = false;
        this.route.params.subscribe((params) => {
          const id = params['id'] as string
          if (id) {
            this.getPromocion(id);
          }
        })
      },
      (error) => {
        // this.cmbTipoPromocion = [];
        this.loading = false;
      }
    )
  }

  back() {
    this.router.navigate(['/promociones']);
  }

  guardar(payload: SavePromocion) {
    payload.promo.fecha_fin = payload.promo.fecha_fin ? payload.promo.fecha_fin + "T23:59:59.873Z" : null;
    payload.promo.fecha_inicio = payload.promo.fecha_inicio ? payload.promo.fecha_inicio + "T00:00:00.873Z" : null;

    if (payload.autosave) {
      this.promocionesService.crearPromo(payload.promo).subscribe((_) => this.getPromocion(this.promocion.id_promo));
      return;
    }

    this._util
      .confirmarSincronoPromesa({
        title: '¿Esta seguro que desea procesar el siguiente formulario?',
        text: `ID PROMO: ${payload.promo.id_promo}`,
        action: 'Editar',
        funcion: this.promocionesService.crearPromo(payload.promo),
      })
      .then((res: any) => {
        this.loading = false;
        this.getPromocion(this.promocion.id_promo);
      });
  }

  downloadCsv() {
    this.promocionesService.downloadCsvClient(this.promocion.id_promo).subscribe((res) => downloadBase64File(res, 'condicion_cliente.csv'))
  }

  onFileGroup(event) {
    let allowedExtensions = /(.csv)$/i;
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      if (!allowedExtensions.exec(file.name)) {
        this.toastrService.error('El tipo de archivo no es valido, el tipo de archivo permitido es "CSV"');
        this.fileGroupInput.nativeElement.value = '';
      } else {
        this.uploadCsv(file, 'group');
      }
    }
  }

  onFileBonos(event) {
    let allowedExtensions = /(.csv)$/i;
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      if (!allowedExtensions.exec(file.name)) {
        this.toastrService.error('El tipo de archivo no es valido, el tipo de archivo permitido es "CSV"');
        this.fileBonosInput.nativeElement.value = '';
      } else {
        this.uploadCsv(file, 'bonos');
      }
    }
  }

  private uploadCsv(file, type: 'group'|'bonos') {
    const formData = new FormData();
    formData.append('file', new Blob([file], { type: 'text/csv' }), 'file');
    const path = type === 'group' ? 'cond-grupo-cliente' : 'promocion';
    this._util
      .confirmarSincronoPromesa({
        title: '¿Esta seguro de enviar el siguiente archivo?',
        text: '',
        action: 'Enviar',
        funcion: this.promocionesService.uploadCsv(this.promocion.id_promo, formData, path)
      })
        .then((res: ApiResponse<string>) => {
          this.toastrService.success(res.mensaje, `${res.key}`);
        })
        .finally(() => {
          if (this.fileGroupInput) this.fileGroupInput.nativeElement.value = '';
          if (this.fileBonosInput) this.fileBonosInput.nativeElement.value = '';
        });
  }
}
